import axios from 'axios'
import {
  PROJECT_ADD_CONTRIB_FAIL,
  PROJECT_ADD_CONTRIB_REQUEST,
  PROJECT_ADD_CONTRIB_SUCCESS,
  PROJECT_ADD_PO_DOCS_FAIL,
  PROJECT_ADD_PO_DOCS_REQUEST,
  PROJECT_ADD_PO_DOCS_SUCCESS,
  PROJECT_AE_ADD_PO_DOCS_FAIL,
  PROJECT_AE_ADD_PO_DOCS_REQUEST,
  PROJECT_AE_ADD_PO_DOCS_SUCCESS,
  PROJECT_ALL_LIST_FAIL,
  PROJECT_ALL_LIST_REQUEST,
  PROJECT_ALL_LIST_SUCCESS,
  PROJECT_ARCHIVE_FAIL,
  PROJECT_ARCHIVE_REQUEST,
  PROJECT_ARCHIVE_SUCCESS,
  PROJECT_CREATE_FAIL,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS,
  PROJECT_DELETE_FAIL,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELIVERABLES_FAIL,
  PROJECT_DELIVERABLES_REQUEST,
  PROJECT_DELIVERABLES_SUCCESS,
  PROJECT_DETAILS_FAIL,
  PROJECT_DETAILS_REQUEST,
  PROJECT_DETAILS_SUCCESS,
  PROJECT_DOCUMENT_SIGNED_FAIL,
  PROJECT_DOCUMENT_SIGNED_REQUEST,
  PROJECT_DOCUMENT_SIGNED_SUCCESS,
  PROJECT_FILES_FAIL,
  PROJECT_FILES_REQUEST,
  PROJECT_FILES_SUCCESS,
  PROJECT_FILE_DELETE_FAIL,
  PROJECT_FILE_DELETE_REQUEST,
  PROJECT_FILE_DELETE_SUCCESS,
  PROJECT_LIST_FAIL,
  PROJECT_LIST_REQUEST,
  PROJECT_LIST_SUCCESS,
  PROJECT_MARK_AS_PAID_FAIL,
  PROJECT_MARK_AS_PAID_REQUEST,
  PROJECT_MARK_AS_PAID_SUCCESS,
  PROJECT_REMOVE_CONTRIB_FAIL,
  PROJECT_REMOVE_CONTRIB_REQUEST,
  PROJECT_REMOVE_CONTRIB_SUCCESS,
  PROJECT_REMOVE_DELIVERABLE_FAIL,
  PROJECT_REMOVE_DELIVERABLE_REQUEST,
  PROJECT_REMOVE_DELIVERABLE_SUCCESS,
  PROJECT_REQUESTS_DETAILS_FAIL,
  PROJECT_REQUESTS_DETAILS_REQUEST,
  PROJECT_REQUESTS_DETAILS_SUCCESS,
  PROJECT_SUBMIT_QUOTE_FAIL,
  PROJECT_SUBMIT_QUOTE_REQUEST,
  PROJECT_SUBMIT_QUOTE_SUCCESS,
  PROJECT_UPDATE_FAIL,
  PROJECT_UPDATE_NO_TOAST,
  PROJECT_UPDATE_QUOTE_FAIL,
  PROJECT_UPDATE_QUOTE_REQUEST,
  PROJECT_UPDATE_QUOTE_SUCCESS,
  PROJECT_UPDATE_REQUEST,
  PROJECT_UPDATE_SUCCESS,
} from '../constants/projectConstants'

export const createProject = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_CREATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`/api/projects`, project, config)

    dispatch({
      type: PROJECT_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getProjectDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROJECT_DETAILS_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/projects/${id}`, config)

    dispatch({
      type: PROJECT_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getProjectFiles = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROJECT_FILES_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/projects/files/${id}`, config)

    dispatch({
      type: PROJECT_FILES_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_FILES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getProjectRequestsDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROJECT_REQUESTS_DETAILS_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/projects/requests/${id}`, config)

    dispatch({
      type: PROJECT_REQUESTS_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_REQUESTS_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateProject = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_UPDATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/projects/${project._id}`,
      project,
      config
    )

    dispatch({
      type: PROJECT_UPDATE_SUCCESS,
      payload: data,
    })

    dispatch({
      type: PROJECT_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const inviteProjectContributors =
  (users) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PROJECT_ADD_CONTRIB_REQUEST,
      })

      const {
        userLogin: { userInfo },
        projectDetails: { project },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.put(
        `/api/projects/add-contributors/${project._id}`,
        users,
        config
      )

      dispatch({
        type: PROJECT_ADD_CONTRIB_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: PROJECT_ADD_CONTRIB_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const removeProjectContributor =
  (contribId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PROJECT_REMOVE_CONTRIB_REQUEST,
      })

      const {
        userLogin: { userInfo },
        projectDetails: { project },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.put(
        `/api/projects/remove-contributor/${project._id}`,
        { contribId },
        config
      )

      dispatch({
        type: PROJECT_REMOVE_CONTRIB_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: PROJECT_REMOVE_CONTRIB_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const submitQuote = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_SUBMIT_QUOTE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/projects/submit-quote/${project._id}`,
      project,
      config
    )

    dispatch({
      type: PROJECT_SUBMIT_QUOTE_SUCCESS,
      payload: data,
    })

    dispatch({
      type: PROJECT_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_SUBMIT_QUOTE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateQuote = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_UPDATE_QUOTE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/projects/update-quote/${project._id}`,
      project,
      config
    )

    dispatch({
      type: PROJECT_UPDATE_QUOTE_SUCCESS,
      payload: data,
    })

    dispatch({
      type: PROJECT_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_UPDATE_QUOTE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const aeAddPurchaseOrderDocs =
  (project) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PROJECT_AE_ADD_PO_DOCS_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.put(
        `/api/projects/ae-add-po-docs/${project._id}`,
        project,
        config
      )

      dispatch({
        type: PROJECT_AE_ADD_PO_DOCS_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: PROJECT_AE_ADD_PO_DOCS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const addPurchaseOrderDocs = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_ADD_PO_DOCS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/projects/add-po-docs/${project._id}`,
      project,
      config
    )

    dispatch({
      type: PROJECT_ADD_PO_DOCS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_ADD_PO_DOCS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getProjectsByUserId = (user) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROJECT_LIST_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      params: {
        user,
      },
    }

    const { data } = await axios.get(`/api/projects/list`, config)

    dispatch({
      type: PROJECT_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getAllProjects =
  (
    page,
    rowsPerPage,
    sort,
    status,
    assignee,
    projectName,
    client,
    company,
    type
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: PROJECT_ALL_LIST_REQUEST })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
        params: {
          user: userInfo,
          page,
          limit: rowsPerPage,
          sort,
          userName: client,
          status,
          assignee,
          projectName,
          company,
          type,
        },
      }

      const { data } = await axios.get(`/api/projects/all`, config)

      dispatch({
        type: PROJECT_ALL_LIST_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: PROJECT_ALL_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const deleteProject = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_DELETE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(`/api/projects/${id}`, config)

    dispatch({ type: PROJECT_DELETE_SUCCESS })
  } catch (error) {
    dispatch({
      type: PROJECT_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteProjectFile = (fileInfo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_FILE_DELETE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.post(`/api/projects/remove-file`, fileInfo, config)

    dispatch({ type: PROJECT_FILE_DELETE_SUCCESS })
  } catch (error) {
    dispatch({
      type: PROJECT_FILE_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const markProjectAsPaid = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_MARK_AS_PAID_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = axios.post(`/api/projects/mark-as-paid/${id}`, id, config)

    dispatch({ type: PROJECT_MARK_AS_PAID_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: PROJECT_MARK_AS_PAID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const markDocumentAsSigned = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_DOCUMENT_SIGNED_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = axios.post(
      `/api/projects/mark-as-signed/${id}`,
      id,
      config
    )

    dispatch({ type: PROJECT_DOCUMENT_SIGNED_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: PROJECT_DOCUMENT_SIGNED_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const removeFileFromDeliverables =
  (project, fileName, fileId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PROJECT_REMOVE_DELIVERABLE_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.post(
        `/api/projects/deliverable-remove`,
        {
          project,
          fileName,
          fileId,
          adminName: `${userInfo.firstName} ${userInfo.lastName}`,
        },
        config
      )

      dispatch({
        type: PROJECT_REMOVE_DELIVERABLE_SUCCESS,
        payload: data,
      })

      dispatch({
        type: PROJECT_UPDATE_NO_TOAST,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: PROJECT_REMOVE_DELIVERABLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const submitDeliverables = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_DELIVERABLES_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `/api/projects/deliverables`,
      project,
      config
    )

    dispatch({
      type: PROJECT_DELIVERABLES_SUCCESS,
      payload: data,
    })

    dispatch({
      type: PROJECT_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_DELIVERABLES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const markProjectAsComplete =
  (project) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PROJECT_UPDATE_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.put(
        `/api/projects/mark-as-complete/${project._id}`,
        project,
        config
      )

      dispatch({
        type: PROJECT_UPDATE_SUCCESS,
        payload: data,
      })

      dispatch({
        type: PROJECT_DETAILS_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: PROJECT_UPDATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const archiveProject = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROJECT_ARCHIVE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/projects/archive/${project._id}`,
      project,
      config
    )

    dispatch({
      type: PROJECT_UPDATE_SUCCESS,
      payload: data,
    })

    dispatch({
      type: PROJECT_ARCHIVE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROJECT_ARCHIVE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
